module.exports = __webpack_public_path__ + "img/高速1.057d89e1.png";